module.exports = __webpack_public_path__ + "img/safe-2.066c8fe5.png";